import { Component, input, TemplateRef, Type, viewChild } from '@angular/core';

@Component({
  standalone: true,
  selector: 'woo-tab',
  template: `
    <ng-template #contentTpl>
      <ng-content></ng-content>
    </ng-template>
  `,
})
export class WooTabComponent {
  readonly label = input.required<string>();
  readonly name = input.required<string>();
  readonly component = input<Type<unknown>>();
  readonly template = viewChild.required<TemplateRef<unknown>>('contentTpl');
  readonly align = input<'start' | 'end'>('start');
}
